module.exports = __webpack_public_path__ + "static/emrearslan-dbc92217c19377507eb5566c778629df.jpeg";